var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileTabIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4823 17.9038C9.97003 17.9038 6.1167 18.586 6.1167 21.3183C6.1167 24.0505 9.94559 24.7571 14.4823 24.7571C18.9945 24.7571 22.8467 24.0738 22.8467 21.3427C22.8467 18.6116 19.0189 17.9038 14.4823 17.9038Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4824 14.007C17.4435 14.007 19.8435 11.6059 19.8435 8.6448C19.8435 5.68369 17.4435 3.28369 14.4824 3.28369C11.5213 3.28369 9.12015 5.68369 9.12015 8.6448C9.11015 11.5959 11.4946 13.997 14.4446 14.007H14.4824Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileTabIcon);
export default __webpack_public_path__ + "static/media/profileTabIcon.3cd5657570a3b003fe32a04832f0fbfb.svg";
export { ForwardRef as ReactComponent };